import React from 'react';
import { Button } from '@/components/ui/button';
import { ShopInsuranceLicensingSheet } from '@/components/ShopInsuranceLicensingSheet';

// Shared content component - exported for reuse in other components
export function ShopInsuranceNoticeContent({ buttonClassName }: { buttonClassName: string }) {
  return (
    <div className="text-start text-xs text-gray-700">
      <p>
        <strong>Insurance & Licensing Notice:</strong> Insurance products and quotes are offered
        through Wealth Assurance Group, LLC, a wholly owned subsidiary of Waterlily, licensed for
        life, health and long-term-care insurance in 49 states and the District of Columbia. Not all
        products are available in every state. If a product is purchased, the producer(s) on your
        application may receive commission based on a percentage of paid premiums, which varies by
        product and state. If Wealth Assurance Group serves as a producer on your application, they
        may receive part or all of that commission. State-specific commission disclosures are
        available upon request.
      </p>

      <ShopInsuranceLicensingSheet>
        <Button
          variant="link"
          className={buttonClassName}
        >
          Learn More
        </Button>
      </ShopInsuranceLicensingSheet>
    </div>
  );
}

// Mobile version - new implementation (subtle footer)
export function ShopInsuranceNoticeBannerMobile() {
  return (
    <div className="border-t border-gray-200 bg-white px-4 py-3">
      <ShopInsuranceNoticeContent buttonClassName="mt-2 h-auto p-0 text-xs font-medium text-gray-700 underline hover:text-gray-900" />
    </div>
  );
}

// Desktop version - old implementation (card style)
export function ShopInsuranceNoticeBannerDesktop() {
  return (
    <div className="mx-2 rounded-lg border border-gray-200 bg-gray-50 px-4 py-4">
      <ShopInsuranceNoticeContent buttonClassName="mt-4 h-auto p-0.5 text-xs font-medium text-gray-700 underline hover:text-gray-900" />
    </div>
  );
}
